module.exports = __webpack_public_path__ + "img/room_empty.05085e47.png";